import { FileSource, User, UserDetailedInfo } from "@/types";

import { axios } from "../axios.instance";

export type FinishProfileRequest = {
  photos: FileSource[];
};

export type FinishProfileResponse = User & UserDetailedInfo;

export const finishProfile = async (body: FinishProfileRequest): Promise<FinishProfileResponse> => {
  const { data } = await axios.patch("users/finish-profile", body);

  return data;
};
